
export function NoResults({
  msg = '데이터가 없습니다.',
  className,
  children
}) {

  return (
    <div className="data__no-results">
      <div className={`data__no-results__msg ir before i-nodata-search ${className}`}>{children || msg}</div>
    </div>
  );
}
